export default __webpack_public_path__ + "static/media/bannerBg.98468088.png";